import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { GetFaceLivenessSessionResultsResponseFilterSensitiveLog, } from "../models/models_0";
import { de_GetFaceLivenessSessionResultsCommand, se_GetFaceLivenessSessionResultsCommand, } from "../protocols/Aws_json1_1";
export { $Command };
export class GetFaceLivenessSessionResultsCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("RekognitionService", "GetFaceLivenessSessionResults", {})
    .n("RekognitionClient", "GetFaceLivenessSessionResultsCommand")
    .f(void 0, GetFaceLivenessSessionResultsResponseFilterSensitiveLog)
    .ser(se_GetFaceLivenessSessionResultsCommand)
    .de(de_GetFaceLivenessSessionResultsCommand)
    .build() {
}
